import type { Drug } from "../types";

export const fluticasoneFuroateNasalSprayDrug: Drug = {
  id: "fluticasone_furoate_nasal_spray",
  name: "Fluticasone furoate nasal spray",
  drugClass: "intranasal corticosteroid",
  route: "nasal",
  administrationNote: "Shake well before use. Prime the spray before first use or if unused for several days.",
  formulations: [
    {
      id: "flut-furoate-27.5mcg-spray",
      type: "nasal_spray",
      strength: 27.5,
      strengthUnit: "mcg",
      actuationDose: 27.5,
      bottleActuations: 120,
      prescribedItemId: "d5a34005-317e-4581-bbd9-23dd5872d35a",
    },
  ],
};
